import { Component, inject, input, output } from '@angular/core'
import { NgbModal, NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap'
import { SmartQuoteService } from 'src/app/core/services/smartquote/smartquote.service'
import { SmartQuote } from 'src/app/shared/interfaces/smartquote/smart-quote.interface'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { SmartquoteEmailModalComponent } from '../smartquote-email-modal/smartquote-email-modal.component'
import { SmartquoteSendOrderModalComponent } from '../smartquote-send-order-modal/smartquote-send-order-modal.component'
import { CalloutComponent } from 'src/app/shared/components/callout/callout/callout.component'
import { RouterLink } from '@angular/router'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { DatePipe } from '@angular/common'
import { NgxPermissionsModule } from 'ngx-permissions'
import { ToastrService } from 'ngx-toastr'
import { PdfModalService } from 'src/app/shared/components/pdf-modal/pdf-modal.service'
import { WolseleyStockCheckOffcanvasComponent } from 'src/app/shared/components/wolseley/wolseley-stock-check-offcanvas/wolseley-stock-check-offcanvas.component'

@Component({
    selector: 'sf-smartquote-top-bar',
    imports: [RouterLink, NgxPermissionsModule, CardComponent, ButtonComponent, CalloutComponent, DatePipe],
    templateUrl: './smartquote-top-bar.component.html',
    styleUrl: './smartquote-top-bar.component.scss',
})
export class SmartquoteTopBarComponent {
    #smartquoteService = inject(SmartQuoteService)
    #modalService = inject(NgbModal)
    #offcanvas = inject(NgbOffcanvas)
    #toastr = inject(ToastrService)
    #pdfModalService = inject(PdfModalService)

    wolseleyStockCheckOffcanvas: NgbOffcanvasRef | null = null

    smartquote = input<SmartQuote | null>()
    email = input<string | null>()
    landingPageUrl = input<string | null>()
    totalCost = input<number | null>()
    totalExVatCost = input<number | null>()
    deposit = input<number | null>()
    canOrderFromWolseley = input<boolean | null>()
    productCodes = input<string[]>([])

    onAccepted = output()
    onDeclined = output()
    onCopy = output()
    onDeleted = output()

    openPDFModal(): void {
        this.#smartquoteService.downloadPdf(this.smartquote()!.id).subscribe({
            next: (response) => {
                this.#pdfModalService.openModal(response, 'SmartQuote')
            },
        })
    }

    openEmailModal(): void {
        const ref = this.#modalService.open(SmartquoteEmailModalComponent, { size: 'xl', fullscreen: 'lg' })
        ref.componentInstance.smartQuoteId = this.smartquote()!.id
        ref.componentInstance.emailAddress = this.email()
        ref.componentInstance.smartQuote = this.smartquote()
    }

    openSendOrderModal(): void {
        const ref = this.#modalService.open(SmartquoteSendOrderModalComponent, { size: 'xl' })
        ref.componentInstance.smartQuoteId = this.smartquote()!.id
    }

    openWolseleyStockCheck(): void {
        const productCodes = this.productCodes()

        if (productCodes.length === 0) {
            this.#toastr.warning('Please add some products (with catalog numbers) to check stock for')
            return
        }

        this.wolseleyStockCheckOffcanvas = this.#offcanvas.open(WolseleyStockCheckOffcanvasComponent, {
            position: 'end',
        })
        this.wolseleyStockCheckOffcanvas.componentInstance.productCodes = productCodes
    }
}
